// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import org.mifospay.core.network.model.entity.register.RegisterPayload
import org.mifospay.core.network.model.entity.register.UserVerify

@OptIn(InternalKtorfitApi::class)
public class _RegistrationServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : RegistrationService {
  override suspend fun registerUser(registerPayload: RegisterPayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "registration")
        }
        setBody(registerPayload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun verifyUser(userVerify: UserVerify) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "registration/user")
        }
        setBody(userVerify) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _RegistrationServiceProvider : ClassProvider<RegistrationService> {
  override fun create(_ktorfit: Ktorfit): RegistrationService = _RegistrationServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createRegistrationService(): RegistrationService = _RegistrationServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
